import { IconsProps } from '@/types/shared'
import React from 'react'

const RecentIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9.7998 18.5C7.4998 18.5 5.49564 17.7375 3.7873 16.2125C2.07897 14.6875 1.0998 12.7833 0.849805 10.5H2.8998C3.13314 12.2333 3.90397 13.6667 5.2123 14.8C6.52064 15.9333 8.0498 16.5 9.7998 16.5C11.7498 16.5 13.404 15.8208 14.7623 14.4625C16.1206 13.1042 16.7998 11.45 16.7998 9.5C16.7998 7.55 16.1206 5.89583 14.7623 4.5375C13.404 3.17917 11.7498 2.5 9.7998 2.5C8.6498 2.5 7.5748 2.76667 6.5748 3.3C5.5748 3.83333 4.73314 4.56667 4.0498 5.5H6.7998V7.5H0.799805V1.5H2.7998V3.85C3.6498 2.78333 4.6873 1.95833 5.9123 1.375C7.1373 0.791667 8.43314 0.5 9.7998 0.5C11.0498 0.5 12.2206 0.7375 13.3123 1.2125C14.404 1.6875 15.354 2.32917 16.1623 3.1375C16.9706 3.94583 17.6123 4.89583 18.0873 5.9875C18.5623 7.07917 18.7998 8.25 18.7998 9.5C18.7998 10.75 18.5623 11.9208 18.0873 13.0125C17.6123 14.1042 16.9706 15.0542 16.1623 15.8625C15.354 16.6708 14.404 17.3125 13.3123 17.7875C12.2206 18.2625 11.0498 18.5 9.7998 18.5ZM12.5998 13.7L8.7998 9.9V4.5H10.7998V9.1L13.9998 12.3L12.5998 13.7Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    )
}

export default RecentIcons
